var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hv-cube",class:_vm.data.type},_vm._l((_vm.data.list),function(item,index){return _c('div',{key:index,staticClass:"hv-cube-item"},[_c('BaseImage',{attrs:{"data":item,"fit":_vm.data.fit}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }